/* eslint-disable react/prop-types */
/* eslint-disable spaced-comment */
import React, { useRef } from 'react';
import { Rect } from 'react-konva';
import Konva from 'konva';
import { positionToNormFreq, clampNumber } from './PlayStage';

const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return [r, g, b, alpha];
  } else {
    return [r, g, b];
  }
};

const buildRgb = (imageData) => {
  const rgbaValues = [];
  for (let i = 0; i < imageData.length; i += 4) {
    const rgba = [imageData[i], imageData[i + 1], imageData[i + 2], imageData[i + 3]];
    rgbaValues.push(rgba);
  }
  return rgbaValues;
};

function Playhead ({ shapeRefs, layerRef, onStartPlay, onStopPlay, animating, tempo }) {
  const rectRef = useRef(null);

  React.useEffect(() => {
    if (!animating) {
      handleReset();
      return;
    }
    const node = rectRef.current;
    const anim = new Konva.Animation(
      (frame) => {
        const layer = layerRef.current;
        const context = layer.getContext();
        const scale = layer.getAbsoluteScale();
        const velocity = 1;
        const distance = velocity * (frame.timeDiff) / scale.x / tempo; // TODO: rename to duration
        const newX = (node.x()) + distance;
        if (newX * scale.x < context.canvas.width - node.width()) {
          node.x(newX);
          checkCollision();
          readShapes();
        } else {
          handleReset();
        }
      },
      [node.getLayer()]
    );
    anim.frameRate = 1000;
    anim.start();
    return () => anim.stop();
  }, [animating, tempo]);

  const handleReset = () => {
    //anim.stop();
    resetPosition();
  };

  const resetPosition = () => {
    rectRef.current.x(0);
  };

  const readShapes = () => {
    const node = rectRef.current;
    const scale = node.getAbsoluteScale();
    const middle = (node.x() + node.width()) * scale.x + 1; // we want to sample just before the playhead
    if (shapeRefs.current[0]) {
      shapeRefs.current.forEach((shape) => {
        if (shape?.getIsPlaying()) {
          const hexColor = shape.getColor();
          const rgbaColor = hexToRGB(hexColor, 255);
          // console.log('analyzing shape: ', shape.getId());
          const [colorCount, middlePoint] = getColorCountInRange(rgbaColor, middle, shape.getY(), shape.getHeight());
          // console.log('count ', colorCount);
          // console.log('middlePoint', middlePoint);
          //console.log('middle point: ', middlePoint);
          if (colorCount > 0) { // TODO: check why color count is 0 sometimes
            const stage = layerRef.current.parent;
            const stageHeight = stage.height();
            const normFreq = positionToNormFreq(shape.getY() + middlePoint, stageHeight);
            // console.log('y: ', shape.getY());
            // console.log('height: ', shape.getHeight());
            // console.log('middlePoint: ', middlePoint);
            // console.log('normFreq: ', normFreq);
            setFreq(shape.getId(), normFreq);
            setAmplitude(shape.getId(), colorCountToAmplitude(colorCount));
          }
        };
      });
    }
  };

  const colorCountToAmplitude = (count) => {
    const stage = layerRef.current.parent;
    const stageHeight = stage.height();
    const amplitude = clampNumber((count / (stageHeight / 3)), 0, 1);
    return amplitude;
  };

  const getColorCountInRange = (color, x, y, height) => {
    const layer = layerRef.current;
    const context = layer.getContext();
    //console.log('scale: ', scale);
    const imageData = context.getImageData(x, y, 1, height);
    const imageDataRGB = buildRgb(imageData.data);
    const count = imageDataRGB.filter(item => item.toString() === color.toString()).length;
    let middlePoint = 0;
    if (count > 0) {
      const firstIdx = imageDataRGB.findIndex(item => item.toString() === color.toString());
      const lastIdx = imageDataRGB.length - 1 - [...imageDataRGB].reverse().findIndex((element) => element.toString() === color.toString());
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx: ', lastIdx);
      middlePoint = (lastIdx + firstIdx) / 2;
    }
    return [count, middlePoint];
  };

  const shapeIdToIdx = (shapeId) => {
    const shapeIdx = shapeRefs.current.findIndex(item => item.getId() === shapeId);
    return shapeIdx;
  };

  const setAmplitude = (id, value) => {
    const idx = shapeIdToIdx(id);
    shapeRefs.current[idx].setAmplitude(value);
  };

  const setFreq = (id, value) => {
    const idx = shapeIdToIdx(id);
    shapeRefs.current[idx].setNormFreq(value); // TODO: make freq, normFreq and playback rate consistent
  };

  const checkCollision = () => {
    const node = rectRef.current;
    const scale = node.getAbsoluteScale();
    if (shapeRefs.current[0]) {
      shapeRefs.current.forEach((soundShape, index) => {
        if (soundShape?.getX() < node.x() * scale.x && soundShape?.getX() + soundShape?.getWidth() > node.x() * scale.x) {
          console.log('collision: ' + soundShape.id);
          onStartPlay(soundShape.getId());
        } else if (soundShape?.getIsPlaying()) {
          onStopPlay(soundShape.getId());
        }
      });
    }
  };

  return (
    <Rect
      width={3}
      fill={'black'}
      height={window.innerWidth}
      stroke={0}
      ref={rectRef}
    />
  );
};

export default Playhead;
